import AxiosClient from "../../services/axios.services";

class CollegedegreeServices {
  getCollegedegrees = (params, iType) =>
    AxiosClient.get(
      iType === 1
        ? "/api/app/Formal_Titulo/"
        : "/api/app/Funcional_Titulo/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  saveCollegedegree = (data, iType) =>
    AxiosClient.post(
      iType === 1
        ? "/api/app/Formal_Titulo/"
        : "/api/app/Funcional_Titulo/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editCollegedegree = (id, data, iType) =>
    AxiosClient.put(
      iType === 1
        ? `/api/app/Formal_Titulo/${id}/`
        : `/api/app/Funcional_Titulo/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteCollegedegree = (id, iType) =>
    AxiosClient.delete(
      iType === 1
        ? `/api/app/Formal_Titulo/${id}/`
        : `/api/app/Funcional_Titulo/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new CollegedegreeServices();
